import { Component, Input } from '@angular/core';
import { MerchantStatement } from '../../../../models/statements/merchantStatement';
import { StatementService } from '../../../../models/statements/statementService';
import { UIErrorHandler } from '../../../../core/uiErrorHandler';
import { StorageService } from '../../../../core/storage/storageService';

@Component({
  selector: 'app-merchant-statements-list',
  templateUrl: './merchant-statements-list.component.html',
  standalone: false,
})
export class MerchantStatementsListComponent {
  @Input() mid: string | undefined;
  @Input() header: string = 'Statements';
  @Input() userId: string | undefined;

  public statements: MerchantStatement[] = [];
  //public pdfUrl: SafeResourceUrl | undefined;
  //public rowIdx: number = -1;
  public isLoading: boolean = false;

  constructor(
    private statementService: StatementService,
    private uiErrorHandler: UIErrorHandler,
    public storage: StorageService,
  ) {}

  ngOnInit() {
    if (this.mid) {
      this.reloadStatements(this.mid, undefined);
    } else if (this.userId) {
      this.reloadStatements(undefined, this.userId);
    }
  }

  ngAfterViewInit() {}

  /*
  view_click(mid:string, statementKey:string|undefined, rowIdx:number) {
    if (statementKey) {
      this.statementService.downloadMerchantStatement(mid, statementKey)
      .then((url:string) => {
        this.pdfUrl = url;
        this.rowIdx = rowIdx;
      });
    }
  }
  */

  download_click(
    mid: string,
    statementHash: string | undefined,
    merchantId: string | undefined,
  ) {
    if (statementHash && mid && merchantId) {
      this.statementService
        .getMerchantStatement(mid, statementHash, merchantId, true)
        .catch((error) => {
          this.uiErrorHandler.handleError(
            'An error occurred while attempting to download the file.',
          );
        });
    }
  }

  btnCheckForNew_click() {
    if (this.mid) {
      this.isLoading = true;
      this.statementService
        .checkForNewStatements(this.mid)
        .then((totalNew) => {
          if (totalNew > 0 && this.mid) {
            this.reloadStatements(this.mid, undefined);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else if (this.userId) {
      this.reloadStatements(undefined, this.userId);
    }
  }

  private reloadStatements(
    mid: string | undefined,
    userId: string | undefined,
  ) {
    this.isLoading = true;
    if (mid) {
      this.statementService
        .getMerchantStatements(mid)
        .then((statements) => {
          this.statements = statements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else if (userId) {
      this.statementService
        .getRecentStatements(userId)
        .then((statements) => {
          this.statements = statements;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
